import { render, staticRenderFns } from "./settlementDetails.vue?vue&type=template&id=2390fa4a"
import script from "./settlementDetails.vue?vue&type=script&lang=js"
export * from "./settlementDetails.vue?vue&type=script&lang=js"
import style0 from "./settlementDetails.vue?vue&type=style&index=0&id=2390fa4a&prod&lang=less"
import style1 from "./settlementDetails.vue?vue&type=style&index=1&id=2390fa4a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports